"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("../../../components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const RequestCodeForm = props => {
  const {
    onSubmit,
    onChange,
    error,
    message,
    state,
    loading
  } = props;
  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: onSubmit,
    className: 'position-relative'
  }, error && /*#__PURE__*/_react.default.createElement("div", {
    className: "alert alert-danger",
    role: "alert"
  }, error.message), message && /*#__PURE__*/_react.default.createElement("div", {
    className: "alert alert-success",
    role: "alert"
  }, message), /*#__PURE__*/_react.default.createElement("div", {
    className: 'form-group mb-4'
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "email",
    className: 'text-muted text-uppercase'
  }, /*#__PURE__*/_react.default.createElement("small", null, "Email")), /*#__PURE__*/_react.default.createElement("input", {
    type: 'email',
    className: 'form-control',
    value: state.username,
    name: 'username',
    onChange: onChange,
    autoComplete: 'off',
    required: true
  })), /*#__PURE__*/_react.default.createElement("button", {
    type: 'submit',
    className: `btn btn-primary`
  }, "Request"), loading && /*#__PURE__*/_react.default.createElement(_components.Spinner, null));
};
var _default = exports.default = RequestCodeForm;
module.exports = exports.default;